export default {
  name: 'gmk-jamon'
};
